import { component } from 'picoapp';

export default component(async (node) => {
  const input = node.querySelector('input');
  const inputDisplay = node.querySelector('[data-quantity]');
  const increase = node.querySelector('[data-increase]');
  const decrease = node.querySelector('[data-decrease]');

  let value = parseInt(input.value, 10);

  increase.addEventListener('click', (event) => {
    event.preventDefault();

    value = Math.max(1, (value += 1));

    input.value = value;
    inputDisplay.textContent = value;
  });

  decrease.addEventListener('click', (event) => {
    event.preventDefault();

    value = Math.max(1, (value -= 1));

    input.value = value;
    inputDisplay.textContent = value;
  });
});
